import React from 'react';
import { Link } from 'react-router-dom';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../context/ThemeContext';
import './styles.scss';

export const Footer: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <footer className={`footer ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8">
        {/* Navigation Links */}
        <div className="mt-8 md:order-1 md:mt-0">
          <nav className="nav-links">
            <Link to="/company">About</Link>
            <Link to="/docs">Documentation</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <p className="mt-4 text-center text-sm">
            &copy; {new Date().getFullYear()} Ticker Tribe. All rights reserved.
          </p>
        </div>

        {/* Social Links */}
        <div className="flex justify-center space-x-6 md:order-2">
          <div className="social-icons">
            <a href="https://www.instagram.com/tickertribe" target="_blank" rel="noopener noreferrer">
              <img src="./instagram-icon.png" alt="Instagram" className="w-6 h-6"/>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src="./twitter-icon.png" alt="Twitter" className="w-6 h-6"/>
            </a>
            <a href="https://www.linkedin.com/company/tickertribe" target="_blank" rel="noopener noreferrer">
              <img src="./linkedIn-icon.png" alt="LinkedIn" className="w-6 h-6"/>
            </a>
          </div>
        </div>

        {/* Theme Toggle */}
        <div className="mt-8 md:order-3 md:mt-0">
          <div className="flex flex-col items-end space-y-3">
            <button 
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            >
              {isDarkMode ? (
                <>
                  <SunIcon className="h-6 w-6" />
                  <span className="ml-2 text-sm">Light</span>
                </>
              ) : (
                <>
                  <MoonIcon className="h-6 w-6" />
                  <span className="ml-2 text-sm">Dark</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};